import { shadow } from '@ahamove/tokens';
import { Button, Group, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useTranslations } from 'next-intl';

// Types
interface ModalFooterProps {
  handleConfirm?: () => void;
  btnText?: string;
  children?: React.ReactNode;
}

const ModalFooter = ({
  handleConfirm,
  btnText,
  children,
}: ModalFooterProps) => {
  const isMobile = useMediaQuery(`(max-width: 768px)`);
  const tCommon = useTranslations('common');

  return (
    <Group
      justify="flex-end"
      mt="auto"
      gap={8}
      p="md"
      pos={{ base: 'fixed', sm: 'sticky' }}
      bottom={0}
      left={0}
      w="100%"
      bg="white"
      styles={{
        root: {
          zIndex: 100,
          borderTop: isMobile
            ? 'none'
            : `1px solid var(--mantine-color-neutral-1)`,
          boxShadow: isMobile ? shadow.buttonDock : 'none',
        },
      }}
    >
      {children ? (
        children
      ) : (
        <Button fullWidth size="md" mih={rem(48)} onClick={handleConfirm}>
          {btnText ? btnText : tCommon('confirm')}
        </Button>
      )}
    </Group>
  );
};

export default ModalFooter;
